import mutations from './mutations';

function state(params = {}) {
    return {
        isLoading: false,

        data: [],
        selected: [],

        meta: {
            current_page: 0,
            total_pages: 0,
            page_size: 24
        },

        params: {
            page: 1,
            page_size: 24,
            sort: null,
            search: null,
            ...params
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations
};